import { Segment, CentreSearchFields } from '../types'

const HEADINGS = {
  centres: 'Centres',
  westfieldProducts: 'Westfield Gift Cards',
  products: 'Products',
  westfieldServices: 'Westfield Services',
  topStores: 'Top Stores',
  events: 'Events',
  offers: 'Offers',
  news: 'News',
  stories: 'Story',
  nearbyStores: 'Other nearby stores',
  nearCentreStores: 'Other stores',
}

type HeadingName = keyof typeof HEADINGS

const getSegmentsToHeadings = (
  headings: Record<HeadingName, string>
): Record<Segment, string> => ({
  westfieldProducts: headings.westfieldProducts,
  retailers: headings.topStores,
  stores: headings.topStores,
  sites: headings.westfieldServices,
  services: headings.westfieldServices,
  offers: headings.offers,
  events: headings.events,
  news: headings.news,
  localStories: headings.stories,
  nationalStories: headings.stories,
  centres: headings.centres,
  onlineServices: headings.westfieldServices,
  nearCentreStores: headings.nearCentreStores,
  products: headings.products,
})

const headingsForCentre = (
  headings: Record<HeadingName, string>,
  centre?: CentreSearchFields
): Record<HeadingName, string> => {
  const centreHeadings = { ...headings }
  if (centre) {
    centreHeadings.nearCentreStores += ` near ${centre.title}`
  }
  return centreHeadings
}

interface HeadingInfo {
  getHeadingForSegment: (s: Segment) => string
  headingsToDisplay: string[]
}

export function makeHeadingInfo(centre?: CentreSearchFields): HeadingInfo {
  const headings = headingsForCentre(HEADINGS, centre)
  const segmentToHeadings = getSegmentsToHeadings(headings)
  const getHeadingForSegment = (segment: Segment): string =>
    segmentToHeadings[segment]
  const headingsToDisplay = Object.values(headings)
  return { getHeadingForSegment, headingsToDisplay }
}
